import { default as endOfTheWorldMarkup } from './endOfTheWorldMarkup.html';
import { default as endOfTheWorldMarkupBinge } from './endOfTheWorldMarkupBinge.html';
import { default as endOfTheWorldMarkupFoxsports } from './endOfTheWorldMarkupFoxsports.html';
import { default as endOfTheWorldMarkupFoxtelgnc } from './endOfTheWorldMarkupFoxtelgnc.html';
import { default as endOfTheWorldMarkupKayo } from './endOfTheWorldMarkupKayo.html';

export const brandSpecificMarkups = {
    dazn: endOfTheWorldMarkup,
    binge: endOfTheWorldMarkupBinge,
    kayo: endOfTheWorldMarkupKayo,
    foxtelgnc: endOfTheWorldMarkupFoxtelgnc,
    foxsports: endOfTheWorldMarkupFoxsports,
};
